import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import EmptyWrapper from "../../common/EmptyWrapper";
import TransactionList from "../VerificationView/TransactionList";
import { ZM_VAT_CATEGORY_CODES } from "../../../utils/zmVatCategories";
import ZmDeclarationsTable from "./ZmDeclarationsTable";
import { ZmDeclarationsSection, ZmExpandedDetails } from "./styledComponents";
import { useZmDeclarations } from "./useZmDeclarations";
import { IZmUser, ZmFilterOptions } from "./types";

const ZmUserDetails = ({
  user,
  filterOptions: { dateFrom, dateTo, missingRecipientVatId },
}: {
  user: IZmUser;
  filterOptions: ZmFilterOptions;
}) => {
  const { t } = useTranslation("ZmView");
  const hasDateRange = Boolean(dateFrom && dateTo);

  const transactionFilterOptions = useMemo(
    () => ({
      email: user.email,
      dateFrom,
      dateTo,
      vatCategoryCodes: [...ZM_VAT_CATEGORY_CODES],
      // Opt-in: only send the flag when on, so the request (and the resulting
      // SQL) is byte-identical to today when the filter is off.
      ...(missingRecipientVatId && { missingRecipientVatId: true }),
    }),
    [user.email, dateFrom, dateTo, missingRecipientVatId]
  );

  const { declarations, loading: declarationsLoading } = useZmDeclarations(
    user.email
  );

  return (
    <ZmExpandedDetails>
      {hasDateRange ? (
        <TransactionList filterOptions={transactionFilterOptions} isNested />
      ) : (
        <EmptyWrapper description={t("details.selectDateRange")} />
      )}
      <ZmDeclarationsSection>
        <ZmDeclarationsTable
          declarations={declarations}
          email={user.email}
          loading={declarationsLoading}
        />
      </ZmDeclarationsSection>
    </ZmExpandedDetails>
  );
};

export default ZmUserDetails;
